"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.FatalSyntaxError = void 0;
/* tslint:disable:max-classes-per-file */
const antlr4ts_1 = require("antlr4ts");
const constants_1 = require("../constants");
const SchemeLexer_1 = require("../lang/SchemeLexer");
const SchemeParser_1 = require("../lang/SchemeParser");
const sExpression_1 = require("../sExpression");
const types_1 = require("../types");
class FatalSyntaxError {
    constructor(location, message) {
        this.location = location;
        this.message = message;
        this.type = types_1.ErrorType.SYNTAX;
        this.severity = types_1.ErrorSeverity.ERROR;
    }
    explain() {
        return this.message;
    }
    elaborate() {
        return 'There is a syntax error in your program';
    }
}
exports.FatalSyntaxError = FatalSyntaxError;
function contextToLocation(ctx) {
    return {
        start: {
            line: ctx.start.line,
            column: ctx.start.charPositionInLine
        },
        end: {
            line: ctx.stop ? ctx.stop.line : ctx.start.line,
            column: ctx.stop ? ctx.stop.charPositionInLine : ctx.start.charPositionInLine
        }
    };
}
class ExpressionGenerator {
    visitChildren(node) {
        throw new FatalSyntaxError(constants_1.UNKNOWN_LOCATION, `invalid syntax ${node.text}`);
    }
    visitList(ctx) {
        return {
            type: 'list',
            elements: ctx.expression().map(ex => ex.accept(this)),
            loc: contextToLocation(ctx)
        };
    }
    visitDottedList(ctx) {
        const expressions = ctx.expression();
        const preExpressions = expressions.slice(0, -1);
        const postExpression = expressions[expressions.length - 1];
        return {
            type: 'dotted list',
            pre: preExpressions.map(ex => ex.accept(this)),
            post: postExpression.accept(this),
            loc: contextToLocation(ctx)
        };
    }
    visitQuote(ctx) {
        return {
            type: 'list',
            elements: [sExpression_1.makeSymbol('quote', true, contextToLocation(ctx)), ctx.expression().accept(this)],
            loc: contextToLocation(ctx)
        };
    }
    visitQuasiquote(ctx) {
        return {
            type: 'list',
            elements: [
                sExpression_1.makeSymbol('quasiquote', true, contextToLocation(ctx)),
                ctx.expression().accept(this)
            ],
            loc: contextToLocation(ctx)
        };
    }
    visitUnquote(ctx) {
        return {
            type: 'list',
            elements: [
                sExpression_1.makeSymbol('unquote', true, contextToLocation(ctx)),
                ctx.expression().accept(this)
            ],
            loc: contextToLocation(ctx)
        };
    }
    visitUnquoteSplicing(ctx) {
        return {
            type: 'list',
            elements: [
                sExpression_1.makeSymbol('unquote-splicing', true, contextToLocation(ctx)),
                ctx.expression().accept(this)
            ],
            loc: contextToLocation(ctx)
        };
    }
    visitString(ctx) {
        return {
            type: 'string',
            // Remove the quotation marks
            value: ctx.text.slice(1, -1),
            loc: contextToLocation(ctx)
        };
    }
    visitNumber(ctx) {
        return {
            type: 'number',
            value: Number(ctx.text),
            loc: contextToLocation(ctx)
        };
    }
    visitBool(ctx) {
        console.assert(ctx.text === '#t' || ctx.text === '#f');
        return {
            type: 'boolean',
            value: ctx.text === '#t' ? true : false,
            loc: contextToLocation(ctx)
        };
    }
    visitIdentifier(ctx) {
        return {
            type: 'symbol',
            isFromSource: true,
            value: ctx.text.toLowerCase(),
            loc: contextToLocation(ctx)
        };
    }
    visitTerminal(node) {
        return node.accept(this);
    }
    visit(tree) {
        return tree.accept(this);
    }
    visitErrorNode(node) {
        throw new FatalSyntaxError({
            start: {
                line: node.symbol.line,
                column: node.symbol.charPositionInLine
            },
            end: {
                line: node.symbol.line,
                column: node.symbol.charPositionInLine + 1
            }
        }, `invalid syntax ${node.text}`);
    }
}
class ThrowingErrorListener {
    static formatErrorMessage(msg) {
        if (msg.includes("mismatched input '<EOF>'")) {
            return 'unexpected EOF';
        }
        else if (msg.includes('no viable alternative')) {
            return msg.replace('no viable alternative', 'syntax error');
        }
        else {
            return msg;
        }
    }
    syntaxError(_recognizer, _offendingSymbol, line, charPositionInLine, msg) {
        throw new FatalSyntaxError({
            start: {
                line,
                column: charPositionInLine + 1
            },
            end: {
                line,
                column: charPositionInLine + 1
            }
        }, ThrowingErrorListener.formatErrorMessage(msg));
    }
}
function convertSource(program) {
    const generator = new ExpressionGenerator();
    return {
        body: program.expression().map(ex => ex.accept(generator))
    };
}
function parse(source, context) {
    const inputStream = new antlr4ts_1.ANTLRInputStream(source);
    const lexer = new SchemeLexer_1.SchemeLexer(inputStream);
    const tokenStream = new antlr4ts_1.CommonTokenStream(lexer);
    const parser = new SchemeParser_1.SchemeParser(tokenStream);
    parser.buildParseTree = true;
    parser.removeErrorListeners();
    parser.addErrorListener(new ThrowingErrorListener());
    let program;
    try {
        const tree = parser.program();
        program = convertSource(tree);
    }
    catch (error) {
        if (error instanceof FatalSyntaxError) {
            context.errors.push(error);
        }
        else {
            throw error;
        }
    }
    const hasErrors = context.errors.find(m => m.severity === types_1.ErrorSeverity.ERROR);
    if (program && !hasErrors) {
        return program;
    }
    else {
        return undefined;
    }
}
exports.parse = parse;
//# sourceMappingURL=parser.js.map